import React, { Suspense, useEffect } from "react";
import Routes from './routes';
import i18n from '@translate/i18n';
import RootStore from '@stores';
import { configure } from 'mobx';
import { observer, Provider } from "mobx-react";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter, Route, Switch, useHistory, Redirect } from "react-router-dom";
import { Lang } from "@interfaces/app";
configure({ enforceActions: 'observed' });
const ExtraService = React.lazy(() => import('@pages/extra'));
const ExtraServiceWhatsapp = React.lazy(() => import('@pages/extra/wechatsApp'));

const App = observer(() => {
  const { language } = RootStore.BasicInfoStore.nativeData;
  const { getJwtToken,  getMGMCode} = RootStore.BasicInfoStore;

  useEffect(() => {
    // getJwtToken();
    getMGMCode()
  }, []);

  //  切換語言環境
  useEffect(() => {
      let lang = navigator.language; //常规浏览器语言和IE浏览器
      lang = lang.substr(0, 2); //截取lang前2位字符
      let locale = lang === 'zh' ? 'zh-HK' : 'en-US';
      // MR-31132: item 20 - set language based on url
      const currentUrl = window.location.href;
      if (currentUrl.includes('/tc')) {
          locale = 'zh-HK';
      } else if (currentUrl.includes('/en')) {
          locale = 'en-US';
      }
      i18n.changeLanguage(locale || 'zh-HK');
  }, [language]);

  return (
      <I18nextProvider i18n={i18n}>
          <Provider>
            <BrowserRouter basename='/portal'>
                <Switch>
                    <Route path="/:lang(tc|en)" render={({ match }) => (
                        <Routes lang={match.params.lang as Lang} />
                    )} />
                    <Route path="/extra/fb" exact>
                        <Suspense fallback={<div></div>}>
                            <ExtraService />
                        </Suspense>
                    </Route>
                    <Route path="/extra/wsapp" render={({ match }) => (
                        <Suspense fallback={<div></div>}>
                            <ExtraServiceWhatsapp />
                        </Suspense>
                    )} />
                    <Route exact path="/">
                        <Redirect to="/tc" />
                    </Route>
                </Switch>
            </BrowserRouter>            
          </Provider>
      </I18nextProvider>
  );
});


export default App;
